
import { connectPagination } from 'instantsearch.js/es/connectors'
// Source : https://www.algolia.com/doc/api-reference/widgets/pagination/js/#full-example
// Create the render function
const renderPagination = (renderOptions, isFirstRender) => {
    const {
        pages,
        currentRefinement,
        nbPages,
        isFirstPage,
        isLastPage,
        refine,
        createURL,
    } = renderOptions;
    const container = document.querySelector('#pagination_produit');

    container.innerHTML = "";
    
    if(nbPages >= 2){
        container.innerHTML = `
            <div class="ccm-pagination-wrapper">
                <ul class="paginationB4">
                        ${isFirstPage === true ? 
                        `
                        <li class="prev disabled">
                            <span><i class="icon-arrow-drop-left-line"></i></span>
                        </li>
                        `
                        :
                        `
                        <li>
                            <a
                                href="${createURL(currentRefinement - 1)}"
                                data-value="${currentRefinement - 1}"
                            >
                                <span><i class="icon-arrow-drop-left-line"></i></span>
                            </a>
                        </li>
                        `
                        }
                ${pages
                    .map(
                    page => `
                        <li class="${currentRefinement === page ? 'active' : ''}" >
                        <a
                            href="${createURL(page)}"
                            data-value="${page}"
                        >
                            ${page + 1}
                        </a>
                        </li>
                    `
                    )
                    .join('')}
                    ${isLastPage === true ?
                    `
                    <li class="disabled">
                        <span><i class="icon-arrow-drop-right-line"></i></span>
                    </li>
                    `
                    :
                    `
                    <li>
                        <a
                        href="${createURL(currentRefinement + 1)}"
                        data-value="${isLastPage ? currentRefinement : currentRefinement + 1}"
                        >
                            <span><i class="icon-arrow-drop-right-line"></i></span>
                        </a>
                    </li>
                    `
                    }   
                </ul>
            </div>
        `;

    }

    [...container.querySelectorAll('a')].forEach(element => {
        element.addEventListener('click', event => {
        event.preventDefault();
        refine(event.currentTarget.dataset.value);
        location.href = "#filtresAlgolia";
        });
    });
};

// Create the custom widget
const customPagination = connectPagination(renderPagination);

export default customPagination;